import { faFingerprint } from "@fortawesome/pro-regular-svg-icons";
import { faCircleNotch } from "@fortawesome/pro-solid-svg-icons/faCircleNotch";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, CardContent, CardHeader, Grid, Stack, Typography } from "@mui/material";
import { APP_NAME } from "app/appConstants";
import { PerformaSessionState } from "app/appModels";
import { AxiosError } from "axios";
import { MprcStringToHtml } from "components";
import { ExtractErrorInformation } from "components/MprcRequestErrorReport";
import React from "react";
import { useTranslation } from "react-i18next";

interface IProps {
    mode: PerformaSessionState;
    lastError?: any;
}

const RenderError = ({ lastError }: { lastError: any; }) => {
    const { t } = useTranslation();
    let error = ExtractErrorInformation(lastError as AxiosError);

    return (
        <Stack id="splashError" direction="column" alignItems="center" spacing={2} >
            {
                error.status == 0 || error.status == 503
                    ? (
                        <Card>
                            <CardHeader title={t("Public.ServerNotAvailable.HeaderTitle")} sx={{ fontSize: 20, backgroundColor: "red", color: "white" }} />
                            <CardContent>
                                <Typography variant="body1" component="div">
                                    <p>{t("Public.ServerNotAvailable.Msg1")}</p>
                                </Typography>
                            </CardContent>
                        </Card>
                    )
                    : (
                        <Card sx={{ maxWidth: 600 }}>
                            <CardHeader title={error.title} sx={{ fontSize: 20, backgroundColor: "red", color: "white" }} />
                            <CardContent>
                                <Typography variant="body1" component="div">
                                    <p>{error.message}</p>
                                    {
                                        error.errorList && Object.values(error.errorList).map(v => <p><MprcStringToHtml text={v} /></p>)
                                    }
                                </Typography>
                                <Typography variant="bodyNotice" component="div">
                                    <p>Status: {error.status}</p>
                                </Typography>
                            </CardContent>
                        </Card>
                    )
            }
        </Stack>
    );
};

export const SplashScreen: React.FC<IProps> = ({ mode, lastError }) => {
    const { t, ready } = useTranslation("shared", { useSuspense: false });
    if (!ready) return null;

    return (
        <Grid container justifyContent="center" alignItems="center" style={{ height: "100vh", backgroundColor: "#fff" }}>
            <Grid>
                <Grid container justifyContent="center" alignItems="center" wrap="nowrap" spacing={4}>
                    <Grid>
                        <img src={"/img/app/App-Logo.png"} alt={APP_NAME} />
                    </Grid>
                    <Grid size="grow">
                        {
                            mode == "error"
                                ? <RenderError lastError={lastError} />
                                : mode == "init" || mode == "checkAccess"
                                    ? (
                                        <Grid container direction="column" justifyContent="center" alignItems="center" wrap="nowrap" spacing={2} color="black">
                                            <Grid>
                                                {
                                                    mode == "init"
                                                        ? <FontAwesomeIcon fixedWidth spin icon={faCircleNotch} size="5x" />
                                                        : <FontAwesomeIcon fixedWidth icon={faFingerprint} size="5x" />
                                                }
                                            </Grid>
                                            <Grid>
                                                {
                                                    mode == "init"
                                                        ? t("App.Startup.Initializing")
                                                        : t("App.Startup.CheckingAccess")
                                                }
                                            </Grid>
                                        </Grid>
                                    )
                                    : mode == "newRelease"
                                        ? (
                                            <Typography variant="h5" color="error">
                                                {
                                                    mode == "newRelease"
                                                        ? <MprcStringToHtml text={t("App.Startup.NewReleaseDetected")} splitChar="$" separator={<br />} />
                                                        : t("App.Startup.InitializeFailed")
                                                }
                                            </Typography>
                                        )
                                        : null
                        }
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};
